import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PRICE_FEATURE_KEY } from '../keys';
import { PriceState } from '../reducers/price.reducer';

export const selectPriceState = createFeatureSelector<PriceState>(PRICE_FEATURE_KEY);

export const selectChainPrice = createSelector(selectPriceState, (state: PriceState) => state.chain.value);
export const selectChainPriceLoaded = createSelector(selectPriceState, (state: PriceState) => state.chain.loaded);
export const selectChainPriceLoading = createSelector(selectPriceState, (state: PriceState) => state.chain.loading);
export const selectChainPriceIsLoaded = createSelector(selectPriceState, (state: PriceState) => state.chain.loaded === true);

export const selectStorePrice = createSelector(selectPriceState, (state: PriceState) => state.store.value);
export const selectStorePriceLoaded = createSelector(selectPriceState, (state: PriceState) => state.store.loaded);
export const selectStorePriceLoading = createSelector(selectPriceState, (state: PriceState) => state.store.loading);
export const selectStorePriceIsLoaded = createSelector(selectPriceState, (state: PriceState) => state.store.loaded === true);

export const selectRates = createSelector(selectPriceState, (state: PriceState) => state.exchanges.rates);
export const selectRatesLoaded = createSelector(selectPriceState, (state: PriceState) => state.exchanges.loaded);
export const selectRatesLoading = createSelector(selectPriceState, (state: PriceState) => state.exchanges.loading);
export const selectRatesIsLoaded = createSelector(selectPriceState, (state: PriceState) => state.exchanges.loaded === true);
